export type Station = {
	Enabled: boolean;
	Id: string;
	Name: string;
	Description: string;
	Owner: string;
	Latitude: number;
	Longitude: number;
	Elevation: number | null;
	HasWindData: boolean;
	HasAirTemperature: boolean;
	HasSeaTemperature: boolean;
	HasWaveData: boolean;
	HasCurrentData: boolean;
	HasStillImages: boolean;
	HasLiveFeed: boolean;
	HasPressure: boolean;
	HasRain: boolean;
	HasDewPoint: boolean;
	HasHumidity: boolean;
	HasWaterLevel: boolean;
	HasVisibility: boolean;
	Measurements: Measurement[]
	Cameras: Camera[]
}

export enum DataSampleType {
	NONE,
	WIND_SPEED,
	WIND_DIRECTION,
	WIND_GUST_SPEED,
	WIND_GUST_DIRECTION,
	CURRENT_SPEED,
	CURRENT_DIRECTION,
	SEATEMP,
	AIRTEMP,
	STILLIMAGE,
	LIVEFEED,
	VISIBILITY,
	DEWPOINT,
	WATER_LEVEL,
	PRESSURE_QNH,
	PRESSURE_QFE_PO,
	PRESSURE_TENDENCY_PP,
	PRESSURE_CHANGE_AA,
	HUMIDITY,
	RAIN_ACCUMULATED
}

export enum DataSampleUnit {
	UNKNOWN,
	METERS_PER_SECOND,
	MILLIMETERS_PER_SECOND,
	KNOTS,
	DEGREE,
	METERS,
	CELSIUS,
	mBar,
	PERCENTAGE,
	FAHRENHEIT,
	PASCAL,
	HPA,
	MILLIMETER
}

export type DataSample = { Source: string, StationId: string, MvId: string, IsInstant: boolean, Timestamp: Date, Unit: DataSampleUnit, Type: DataSampleType, Value: number, Valid: boolean };

export type Measurement = { Id: string, IsInstValue: boolean, IsHistValue: boolean, SampleType: DataSampleType, Unit: DataSampleUnit }
export type Camera = { Enabled: boolean, Id: string, Name: string, IsLive: boolean; DirectUrl: string }

export type BadgeKind = "current" | "wave" | "camera" | "wind" | "temp" | "video" | "rain" | "pressure" | "humidity";
export type StationStatus = 'fresh' | 'stale' | 'offline';